import SettingTypes from '@/utils/setting-types'

export default {
  name: 'coupon',
  decor_type: 'admin,seller',
  label: {
    title: '优惠券',
    icon: require('@/assets/icon-component-label_Coupon.svg'),
    limit: 20
  },
  sort: 2.3,
  data: {
    coupon_mode: 'manual',
    coupon_ids: [],
    coupon_list: [],
    layout: 'horizontal',
    card_style: 'style-3',
    theme_color: '#ff4d35',
    hide_unavailable: true
  },
  settings: {
    coupon_config: {
      type: SettingTypes.custom,
      component_name: 'CouponSettingSelector'
    }
  }
}
